module.exports = __webpack_public_path__ + "img/guardians-white.cad53cb0.png";